import React from "react";
import Tags from "react-tag-input";
import NewTags from "@techsoftware/happay-widgets/Tags";

const ReactTags = props => {
    const { isWidgetComp = false, placeholder = "" } = props;
    if (isWidgetComp) {
        return <NewTags hintText={placeholder || "Enter Mail ID"} {...props} />;
    }
    return <Tags.WithContext {...props} />;
};

export default ReactTags;
